export type PathViewRights = {
  mayViewSubscription: boolean;
  mayViewAutomation: boolean;
};

const canSeeRoute = (
  { mayViewSubscription, mayViewAutomation }: PathViewRights,
  link: string,
  isDHAdmin: boolean,
): boolean => {
  if (link === '/-/settings/subscription') return mayViewSubscription;
  if (link === '/-/settings/automation') {
    return mayViewAutomation;
  }
  if (link === '/-/settings/lfa') {
    return isDHAdmin;
  }

  return true;
};
export default canSeeRoute;
